import React from 'react';
import Button from '../../../../../components/Button';
import Select from '../../../../../components/input/Select/Select';
import Anchor from '../../../../../components/link/Anchor';
import TableFilterInput from '../../../../../components/table/TableFilterInput';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenCsQnaQuestion from '../../../../../containers/cs/qna/common/OpenCsQnaQuestion';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { CS_QNA_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import {
  CS_QNA_RESPONSE_STATUS_SELECT_LIST,
  CS_QNA_RESPONSE_STATUS_TEXT,
  CS_QNA_STATUS_SELECT_LIST,
  CS_QNA_STATUS_TEXT,
} from '../../../../../constants/service/app/csQnaConstants';
import { openNewWindow, reDirectPage, setColumnWidth, setDetailPageUrl } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';

/**
 *  상품 문의 리스트 컬럼
 */
const columns = (data) => {
  const { list, filterOption, onFilter } = data;
  return [
    {
      accessor: 'isResponse',
      Header: '답변 처리',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <Button
          isRadius
          color={row.value ? 'primary' : 'red'}
          text={CS_QNA_RESPONSE_STATUS_TEXT[row.value]}
          onClick={() => reDirectPage({ path: setDetailPageUrl(CS_QNA_DETAIL_URL_PATH, row.original.id) })}
        />
      ),
      Filter: () => (
        <Select
          list={CS_QNA_RESPONSE_STATUS_SELECT_LIST}
          onChange={(isResponse) => onFilter({ isResponse })}
          defaultValue={filterOption.isResponse}
          value={filterOption.isResponse}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'id',
      Header: '상품 문의 ID',
      filterable: true,
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <Anchor
          isUnderLine
          color="primary"
          text={row.value}
          onClick={() => openNewWindow(setDetailPageUrl(CS_QNA_DETAIL_URL_PATH, row.value))}
        />
      ),
      Filter: () => <TableFilterInput option={filterOption.id} onFilter={(id) => onFilter({ id })} />,
    },
    {
      accessor: 'status',
      Header: '상태',
      filterable: true,
      fixed: 'left',
      width: 140,
      Cell: (row) => CS_QNA_STATUS_TEXT[row.value] || '_',
      Filter: () => (
        <Select
          list={CS_QNA_STATUS_SELECT_LIST}
          onChange={(status) => onFilter({ status })}
          defaultValue={filterOption.status}
          value={filterOption.status}
          isTable={true}
          size="large"
        />
      ),
    },
    {
      accessor: 'productId',
      Header: '상품번호(AMONDZ)',
      filterable: true,
      fixed: 'left',
      width: 150,
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productId} onFilter={(productId) => onFilter({ productId })} />
      ),
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      filterable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'productName'),
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.productName} onFilter={(productName) => onFilter({ productName })} />
      ),
    },
    {
      accessor: 'storeName',
      Header: '상점명',
      resizable: true,
      filterable: true,
      width: setColumnWidth(list, 'storeName'),
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 70,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'question',
      Header: '문의내용',
      className: 'align-left',
      resizable: true,
      filterable: true,
      width: 400,
      Cell: (row) => <OpenCsQnaQuestion text={row.value} question={row.value} answer={row.original.answer} />,
      Filter: () => <TableFilterInput option={filterOption.question} onFilter={(question) => onFilter({ question })} />,
    },
    {
      accessor: 'answer',
      Header: '답변내용',
      className: 'align-left',
      resizable: true,
      width: 400,
      Cell: (row) => <OpenCsQnaQuestion text={row.value} question={row.original.question} answer={row.value} />,
    },
    {
      accessor: 'answerDate',
      Header: '답변 일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.answerDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ answerDate: data })}
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '문의 작성 일자',
      sortable: true,
      filterable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
